import React from "react";
import {ICommentListData} from "../../../contracts/data/comment";

const ShowDetailsComment:React.FC<{data: ICommentListData}> = ({data}) => {
    return(
        <div className={"space-y-3"}>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>نام و نام خانوادگی کاربر: </div>
                <div className={"text-sm ml-2"}>{data?.user}</div>
            </div>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>عنوان محصول:</div>
                <div className={"text-sm ml-2"}>{data?.video_product_title}</div>
            </div>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>لایک:</div>
                <div className={"text-sm ml-2"}>{data?.like_count}</div>
            </div>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>دیسلایک:</div>
                <div className={"text-sm ml-2"}>{data?.dislike_count}</div>
            </div>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>زمان ایجاد:</div>
                <div className={"text-sm ml-2"}>{data?.jalali_created_time}</div>
            </div>
            <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>متن نظر:</div>
                <div className={"text-sm ml-2"}>{data?.content}</div>
            </div>
            {data?.answer && <div className={"flex flex-row justify-start items-center"}>
                <div className={"text-gray-800 text-sm ml-2"}>پاسخ نظر:</div>
                <div className={"text-sm ml-2"}>{data?.answer}</div>
            </div>}
        </div>
    )
}

export default ShowDetailsComment